<template>
  <div>
    <div class="content-box">
      <div class="row">
        <div class="col-8">
          <div class="element-wrapper">
            <div class="element-box">
              <router-link
                style="font-size: 15px"
                :to="{ name: 'bancos-movimiento-bancario', params: {} }"
              >
                <i class="fas fa-chevron-left"></i>
                Regresar
              </router-link>
              <div class="col-12">
                <div class="col-12">
                  &nbsp;&nbsp;
                  <!-- aqui se empieza el menu de opciones  -->
                  <div class="st-meta float-right">
                    <div class="element-actions">
                      <div class="btn-group">
                        <button
                          aria-expanded="false"
                          aria-haspopup="true"
                          class="btn btn-secondary dropdown-toggle"
                          data-toggle="dropdown"
                          type="button"
                        >
                          <i class="fa fa-cogs"> </i>
                          Acciones
                        </button>
                        <div class="dropdown-menu dropdown-menu-right">
                          <button
                            class="dropdown-item"
                            :class="{ disabled: !(current.estado == 'B') }"
                            @click="abrir"
                            :disabled="!(current.estado == 'B')"
                            href="#"
                          >
                            <i class="fa fa-unlock"> </i>
                            Abrir Operación
                          </button>
                          <button
                            class="dropdown-item"
                            @click="cerrar"
                            :disabled="!(current.estado == 'A')"
                            href="#"
                          >
                            <i class="fa fa-lock"> </i>
                            Cerrar Operación
                          </button>
                          <button
                            class="dropdown-item"
                            @click="Imprimir()"
                            :disabled="!(current.estado == 'B')"
                            href="#"
                          >
                            <i class="fa fa-print"> </i>
                            Imprimir Constancia
                          </button>
                          <button
                            class="dropdown-item"
                            @click="anular"
                            :disabled="!(current.estado != '9')"
                            href="#"
                          >
                            <i class="fa fa-trash"> </i>
                            Anular Operación
                          </button>
                          <div class="dropdown-divider"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- aqui se termina el menu de opciones -->
                </div>
                <br />
                <div class="col-12">
                  <div class="form-desc" v-if="!current.id">
                    <h5 class="text-primary">
                      <i class="fas fa-info-circle"></i> Añadir Nuevo Movimiento Bancario
                    </h5>
                  </div>
                  <div class="row">
                    <div class="col-12" style="text-align: left" v-if="current.id">
                      <span class="font-weight-bold" style="font-size: 27px"
                        >Movimiento Bancario #{{ current.numero }}
                      </span>
                      <hr />
                    </div>
                  </div>
                </div>
              </div>
              <nav>
                <div>
                  <div class="col-12">
                    <div
                      class="tab-pane fade show active"
                      id="cuentasContable"
                      role="tabpanel"
                      aria-labelledby="barras-tab"
                    >
                      <br />
                      <div class="row">
                        <div class="col-lg-12">
                          <button
                            v-if="current.estado == 'A' && current.id != null"
                            type="button"
                            class="btn btn-md btn-info float-right"
                            @click="showModalCargo()"
                          >
                            <i class="fa fa-plus"></i> Nueva Linea
                          </button> 
                        </div>
                      </div>
                      <div class="row">
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <h5 class="text-success" v-if="current.id != null">
                          Detalle de Contabilización
                        </h5>
                        &nbsp; &nbsp;
                      </div>
                      <br />
                      <div class="table-responsive" v-if="current.id != null">
                        <table class="table table-striped">
                          <thead>
                            <tr>
                              <th class="text-left">Centro Costo</th>
                              <th class="text-left">Cuenta Contable</th>
                              <th class="text-center">Cargo</th>
                              <th class="text-center">Abono</th>
                              <th class="text-center">Opciones</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="detalle in current.movimientobancariocontab_set"
                              v-bind:key="detalle.id"
                            >
                              <td class="text-left">
                                {{ detalle.centro_costo.nombre }}
                              </td>
                              <td class="text-left">
                                {{ detalle.cuenta_contable.id }} -
                                {{ detalle.cuenta_contable.nombre }}
                              </td>
                              <td class="text-right">{{ detalle.cargo }}</td>
                              <td class="text-right">{{ detalle.abono }}</td>
                              <td class="text-center" style="width: 200px">
                                <button
                                  class="btn btn-sm btn-danger mr-1"
                                  type="button"
                                  v-if="current.estado == 'A'"
                                  @click="eliminarContabilizacion(detalle)"
                                >
                                  <i class="fa fa-trash"></i>
                                </button>
                              </td>
                            </tr>
                          </tbody>
                          <tfoot style="background-color: #eaeaea">
                            <tr>
                              <td class="font-weight-bold text-left" colspan="1">
                                <span style="font-size: 17px">Totales</span>
                              </td>
                              <td colspan="1"></td>
                              <td class="text-right">
                                <span
                                  style="font-size: 15px"
                                  class="font-weight-bold"
                                  v-bind:class="{
                                    'text-danger':
                                      current.total_cargos != current.total_abonos,
                                  }"
                                  >Q {{ current.total_cargos }}</span
                                >
                              </td>
                              <td class="text-right font-weight-bold">
                                <span
                                  style="font-size: 15px"
                                  v-bind:class="{
                                    'text-danger':
                                      current.total_cargos != current.total_abonos,
                                  }"
                                  >Q {{ current.total_abonos }}</span
                                >
                              </td>
                              <td colspan="4"></td>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                      <hr />
                      <div class="row">
                        <div class="col-12">
                          <div class="form-group">
                            <label
                              v-bind:class="{
                                'text-danger':
                                  current.errors.descripcion &&
                                  current.errors.descripcion.length > 0,
                              }"
                              >Descripción</label
                            >
                            <textarea
                              :disabled="current.estado != 'A'"
                              v-model="current.descripcion"
                              autofocus="autofocus"
                              class="form-control"
                              placeholder="Ej. Movimiento realizado para pago de..."
                              type="text"
                              rows="5"
                              v-bind:class="{
                                'is-invalid':
                                  current.errors.descripcion &&
                                  current.errors.descripcion.length > 0,
                              }"
                            ></textarea>
                            <small
                              v-if="current.errors && current.errors.descripcion"
                              class="form-text text-danger"
                              >{{ current.errors.descripcion[0] }}</small
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </nav>
            </div>
          </div>
        </div>
        <div
          class="col-4 panel panel-hover"
          style="position: fixed; right: 1vw; width: 26vw"
        >
          <div class="row">
            <div class="col-12">
              <h5 class="text-center">DATOS MOVIMIENTO BANCARIO</h5>
              &nbsp;
              <div
                v-if="current.id"
                class="badge"
                :class="{
                  'badge-success': current.estado == 'A',
                  'badge-warning': current.estado == 'B',
                  'badge-danger': current.estado == '9',
                }"
              >
                <i class="os-icon os-icon-ui-09"></i>
                <span v-if="current.estado_str">{{ current.estado_str }}</span>
                <span v-if="!current.estado_str">En Proceso</span>
              </div>
              &nbsp;
              <div
                v-if="current.id"
                class="badge"
                :class="{
                  'badge-danger': current.total_cargos != current.total_abonos,
                  'badge-warning': current.total_cargos == 0 && current.total_abonos == 0,
                }"
              >
                <span v-if="current.total_cargos != current.total_abonos"
                  ><i class="os-icon os-icon-alert-octagon"></i>&nbsp;Detalle
                  descuadrado</span
                >
              </div>
              <div
                v-if="current.id"
                class="badge"
                :class="{ 'badge-success': current.conciliado == true }"
              >
                <span><i class="os-icon os-icon-ui-93"></i>&nbsp;Conciliado</span>
                <i class="fas fa-check"></i>
              </div>
              <hr />
            </div>
            <div class="col-12">
              <label>Fecha de Movimiento</label>
              <input
                :format="'dd/MM/yyyy'"
                class="form-control form-control-sm text-left"
                :disabled="current.estado != 'A'"
                type="date"
                v-bind:class="{
                  'is-invalid': current.errors.fecha && current.errors.fecha.length > 0,
                }"
                v-model="current.fecha"
              />
              <small
                v-if="current.errors && current.errors.fecha"
                class="form-text text-danger"
                >{{ current.errors.fecha[0] }}</small
              >
            </div>
            <div class="col-12">
              <label
                v-bind:class="{
                  'text-danger':
                    current.errors.tipo_movimiento &&
                    current.errors.tipo_movimiento.length > 0,
                }"
                >Tipo</label
              >
              <select
                :disabled="current.estado != 'A'"
                class="form-control"
                autofocus="autofocus"
                v-model="current.tipo_movimiento"
              >
                <option value="CH">CHEQUE</option>
                <option value="DP">DEPOSITO</option>
                <option value="DV">DEPOSITOS VARIOS</option>
                <option value="NC">NOTA DE CREDITO</option>
                <option value="ND">NOTA DE DEBITO</option>
                <option value="RD">REDEPOSITO</option>
                <option value="SI">SALDO INCIAL</option>
                <option value="TF">TRANSFERENCIA</option>
              </select>
              <small
                v-if="current.errors && current.errors.tipo_movimiento"
                class="form-text text-danger"
                >{{ current.errors.tipo_movimiento[0] }}</small
              >
            </div>
            <div class="col-12">
              <label
                v-bind:class="{
                  'text-danger':
                    current.errors.cuenta_bancaria &&
                    current.errors.cuenta_bancaria.length > 0,
                }"
                >Cuenta Bancaria</label
              >
              <select
                :disabled="current.estado != 'A'"
                class="form-control"
                autofocus="autofocus"
                v-model="current.cuenta_bancaria"
                @change="refreshCuenta"
                @input="$emit('input', $event.target.value)"
              >
                <option v-for="(c, key) in cuentas" :value="c.id" :key="key">
                  {{ c.id }} - {{ c.nombre }}
                </option>
              </select>
              <small
                v-if="current.errors && current.errors.cuenta_bancaria"
                class="form-text text-danger"
                >{{ current.errors.cuenta_bancaria[0] }}</small
              >
            </div>
            <div class="col-12">
              <label
                v-bind:class="{
                  'text-danger':
                    current.errors.tienda && current.errors.tienda.length > 0,
                }"
                >Centro Costo</label
              >
              <select
                :disabled="current.estado != 'A'"
                class="form-control"
                autofocus="autofocus"
                v-model="current.tienda"
                @change="refreshTienda"
                @input="$emit('input', $event.target.value)"
              >
                <option v-for="(c, key) in tiendas" :value="c.codigo" :key="key">
                  {{ c.codigo }} - {{ c.nombre }}
                </option>
              </select>
              <small
                v-if="current.errors && current.errors.tienda"
                class="form-text text-danger"
                >{{ current.errors.tienda[0] }}</small
              >
            </div>
            <div class="col-12">
              <label
                v-bind:class="{
                  'text-danger':
                    current.errors.dias_reserva && current.errors.dias_reserva.length > 0,
                }"
                >Dias de Reserva</label
              >
              <input
                :disabled="current.estado != 'A'"
                v-model="current.dias_reserva"
                class="form-control"
                placeholder="Días de Reserva"
                v-bind:class="{
                  'is-invalid':
                    current.errors.dias_reserva && current.errors.dias_reserva.length > 0,
                }"
                type="text"
              />
              <small
                v-if="current.errors && current.errors.dias_reserva"
                class="form-text text-danger"
                >{{ current.errors.dias_reserva[0] }}</small
              >
            </div>
            <div class="col-12">
              <label
                v-bind:class="{
                  'text-danger':
                    current.errors.referencia && current.errors.referencia.length > 0,
                }"
                >Docto. Referencia</label
              >
              <input
                :disabled="current.estado != 'A'"
                v-model="current.referencia"
                autofocus="autofocus"
                class="form-control"
                placeholder="Referencia"
                type="text"
                v-bind:class="{
                  'is-invalid':
                    current.errors.referencia && current.errors.referencia.length > 0,
                }"
              />
              <small
                v-if="current.errors && current.errors.referencia"
                class="form-text text-danger"
                >{{ current.errors.referencia[0] }}</small
              >
            </div>
            <div class="row">
              <div class="col-6">
                <label>Cargos</label>
                <div class="input-group input-group-md">
                  <div class="input-group-prepend">
                    <div style="background-color: #9ad473" class="input-group-text">
                      Q
                    </div>
                  </div>
                  <input
                    class="form-control text-right"
                    :disabled="current.estado != 'A'"
                    v-model="current.cargo"
                    placeholder="Total Cargado"
                    type="text"
                    @input="formatCargo()"
                  />
                  <small
                    v-if="current.errors && current.errors.cargo"
                    class="form-text text-danger"
                    >{{ current.errors.cargo[0] }}</small
                  >
                </div>
              </div>
              <div class="col-6">
                <label>Abonos</label>
                <div class="input-group input-group-md">
                  <div class="input-group-prepend">
                    <div style="background-color: #9ad473" class="input-group-text">
                      Q
                    </div>
                  </div>
                  <input
                    class="form-control text-right"
                    :disabled="current.estado != 'A'"
                    v-model="current.abono"
                    placeholder="Total Abonado"
                    type="text"
                    @input="formatAbono()"
                  />
                  <small
                    v-if="current.errors && current.errors.abono"
                    class="form-text text-danger"
                    >{{ current.errors.abono[0] }}</small
                  >
                </div>
              </div>
              <div class="col-12">
                <br />
                <button
                  class="btn btn-primary btn-block"
                  @click="guardar()"
                  :disabled="current.estado != 'A'"
                >
                  <i class="far fa-save"></i> Guardar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      aria-hidden="true"
      class="modal fade"
      id="modalAgregarCargo"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header faded smaller" style="background-color: #dddeff">
            <h5 class="modal-title">Añadir Detalle Contabilización</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <div class="row">
                <div class="col-sm-12 col-md-12">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                        'text-danger': errors && errors.centro_costo,
                      }"
                      >Centro Costo</label
                    >
                    <select
                      class="form-control"
                      autofocus="autofocus"
                      v-model="currentDetalle.centro_costo"
                      @change="refreshCentroCosto"
                    >
                      <option v-for="(c, key) in centrocosto" :value="c.id" :key="key">
                        {{ c.id }} - {{ c.nombre }}
                      </option>
                    </select>
                    <small
                      v-if="errors && errors.centro_costo"
                      class="form-text text-danger"
                      >{{ errors.centro_costo[0] }}</small
                    >
                  </div>
                </div>
                <div class="col-sm-12 col-md-12">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                        'text-danger': errors && errors.cuenta_contable,
                      }"
                      >Cuenta Contable</label
                    >
                    <select
                      class="form-control"
                      autofocus="autofocus"
                      v-model="currentDetalle.cuenta_contable"
                    >
                      <option v-for="(c, key) in cuenta" :value="c.id" :key="key">
                        {{ c.id }} - {{ c.nombre }}
                      </option>
                    </select>
                    <small
                      v-if="errors && errors.cuenta_contable"
                      class="form-text text-danger"
                      >{{ errors.cuenta_contable }}</small
                    >
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                        'text-danger': errors && errors.cargo,
                      }"
                      >Cargo</label
                    >
                    <input
                      v-model="currentDetalle.cargo"
                      class="form-control"
                      placeholder="Cantidad"
                      type="number"
                      style="text-align: center; font-size: 200%"
                      v-bind:class="{
                        'is-invalid': errors && errors.cargo,
                      }"
                    />
                    <small v-if="errors && errors.cargo" class="form-text text-danger">{{
                      errors.cargo
                    }}</small>
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                        'text-danger': errors && errors.abono,
                      }"
                      >Abono</label
                    >
                    <input
                      v-model="currentDetalle.abono"
                      class="form-control"
                      placeholder="Cantidad"
                      type="number"
                      style="text-align: center; font-size: 200%"
                      v-bind:class="{
                        'is-invalid': errors && errors.abono,
                      }"
                    />
                    <small v-if="errors && errors.abono" class="form-text text-danger">{{
                      errors.abono
                    }}</small>
                  </div>
                </div>
                <br />
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button class="btn btn-info" @click="agregaCargo()" type="button">
              <i class="far fa-save"></i> Guardar
            </button>
            <button
              class="btn btn-outline-dark"
              ref="cerrarModal"
              data-dismiss="modal"
              type="button"
            >
              <i class="fa fa-door-open"></i> Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import MovimientoBancarioService from "@/services/bancos/MovimientoBancarioService";
import Notifications from "@/notifications/notifications";
import DynamicService from "@/services/commons/DynamicService";

export default {
  watch: {
    current: {
      handler: function (newValue) {
        this.current.cargo = newValue.cargo
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        this.current.abono = newValue.abono
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      },
      deep: true,
    },
  },
  data() {
    return {
      currentDetalle: {
        cargo: 0,
        abono: 0,
      },
      errors: [],
      current: {
        estado: "A",
        errors: {},
      },
    };
  },

  computed: {
    ...mapGetters({
      tiendas: "catalogos/tiendas",
      cuentas: "catalogos/cuentas",
      centrocosto: "catalogos/centro_costo",
      cuenta: "conta/cuenta_contable",
    }),
  },
  mounted() {
    if (this.$route.params.id) {
      this.refreshCurrent();
    }
    this.refreshTienda();
    this.refreshCuenta();
    this.refreshCentroCosto();
    this.refreshCuentaContable();
  },

  methods: {
    formatCargo() {
      let self = this;
      self.current.cargo = self.formatNumber(self.current.cargo);
    },
    formatAbono() {
      let self = this;
      self.current.abono = self.formatNumber(self.current.abono);
    },
    formatNumber(valor) {
      if (!valor) {
        return;
      }
      valor = valor.toString().replace(/,/g, "");
      if (valor.includes(".")) {
        valor = valor.replace(/\./g, "");
        valor = valor.toString().replace(/(\d{2})$/, ".$1");
      }
      return valor.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    eliminarContabilizacion(detalle) {
      let self = this;
      Notifications.alert.confirm(
        "Eliminar detalle de movimiento bancario",
        "¿Esta seguro(a)?",
        "",
        function () {
          DynamicService.postAction(
            "bancos",
            "movimiento-bancario",
            self.current.id,
            "eliminar_detalle",
            {
              id: detalle.id,
            }
          )
            .then((response) => {
              Notifications.alert.success(
                "Eliminar detalle de movimiento bancario",
                "Eliminado correctamente"
              );
              self.refreshCurrent();
            })
            .catch((err) => {
              self.errors = err.response.data;
              if (err.response.data.detail) {
                Notifications.alert.error(
                  "Eliminar detalle de movimiento bancario",
                  err.response.data.detail
                );
              }
            });
        }
      );
    },
    customFormatterInverted(date) {
      if (date == null) {
        return "";
      }
      var d = date.split("/");
      var str_d = d[2] + "-" + d[1] + "-" + d[0];
      return moment(str_d).add("days").format("YYYY-MM-DD");
    },
    refreshCurrent() {
      let self = this;
      MovimientoBancarioService.getById(this.$route.params.id).then((response) => {
        self.current = response.data;
        self.current.tienda = response.data.tienda;
        self.current.cuenta_contable = self.current.cuenta_contable;
        self.current.estado_str = self.current.estado_str;
        self.current.tienda = self.current.tienda.codigo;
        self.current.cuenta_bancaria = self.current.cuenta_bancaria.id;
        self.current.errors = [];
        self.current.fecha = self.customFormatterInverted(self.current.fecha);
      });
    },

    refreshCentroCosto() {
      let self = this;
      self.$store.dispatch("catalogos/centro_costo", {
        activa: true,
        quitar_paginacion: true,
      });
    },
    refreshCuentaContable() {
      let self = this;
      self.$store.dispatch("conta/cuenta_contable", {
        activa: true,
        quitar_paginacion: true,
      });
    },

    refreshTienda() {
      let self = this;
      self.$store.dispatch("catalogos/tiendas", {
        activa: true,
        quitar_paginacion: true,
      });
    },

    refreshCuenta() {
      let self = this;
      self.$store.dispatch("catalogos/cuentas", {
        activa: true,
        quitar_paginacion: true,
      });
    },

    showModalCargo() {
      let self = this;
      $("#modalAgregarCargo").modal();
    },
    cleanDataAggDetalle() {
      let self = this;
      self.currentDetalle.abono = 0;
      self.currentDetalle.cargo = 0;
      self.currentDetalle.centro_costo = "";
      self.currentDetalle.cuenta_contable = "";
    },
    agregaCargo() {
      let self = this;
      let det = Object.assign({}, self.currentDetalle);
      MovimientoBancarioService.agregar_detalle(self.current.id, {
        centro_costo: det.centro_costo,
        cuenta_contable: det.cuenta_contable,
        cargo: det.cargo,
        abono: det.abono,
      })
        .then((response) => {
          Notifications.alert.success("Listo", "Se ha Agregado el detalle.");
          self.refreshCurrent();
          self.$refs.cerrarModal.click();
          self.cleanDataAggDetalle();
        })
        .catch((error) => {
          self.errors = [];
          self.errors = error.response.data;
          if (error.response.data.detail) {
            Notifications.alert.error("agregar detalle", error.response.data.detail);
          }
        });
    },

    guardar() {
      let self = this;
      var current = Object.assign({}, this.current);
      if (this.$route.params.id) {
        current.pk = this.$route.params.id;
        delete current.id;
      }
      if (current.cargo) {
        current.cargo = current.cargo.replace(/,/g, "");
      }
      if (current.abono) {
        current.abono = current.abono.replace(/,/g, "");
      }
      if (self.current.fecha) {
        current.fecha = moment(self.current.fecha).format("DD/MM/YYYY");
      }
      MovimientoBancarioService.save(current)
        .then((res) => {
          self.current = res.data;
          self.current.errors = {};
          Notifications.alert.success("Éxito", "Se ha guardado la Información.");
          self.$router.push({
            name: "bancos-movimiento-bancario-editar",
            params: { id: self.current.id },
          });
          self.refreshCurrent();
        })
        .catch((error) => {
          Vue.nextTick(function () {
            self.current.errors = Object.assign({}, error.response.data);
            console.log(self.current.errors);
          });
        });
    },
    abrir() {
      let self = this;
      Notifications.alert.confirm(
        "Edición de Documento",
        "El documento se encuentra cerrado, ¿desea abrir la transacción?",
        "Si Abrir",
        function () {
          MovimientoBancarioService.abrir(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Documento Abierto",
                "Se abrió la operación para continuar con su edición"
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error("Abrir Transacción", error.response.data.detail);
            });
        }
      );
    },
    cerrar() {
      let self = this;
      Notifications.alert.confirm(
        "Cerrar Operación",
        "¿Está seguro?",
        "Si, cerrar",
        function () {
          MovimientoBancarioService.cerrar(self.current.id)
            .then((response) => {
              Notifications.alert.success("Éxito", "Se ha cerrado la transacción.");
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error("Cerrar Transacción", error.response.data.detail);
            });
        }
      );
    },
    Imprimir() {
      let op;
      op = this.$route.params.id.replace(/-/g, "");
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=bancos/mov_bancario/mov_bancario_report.jrxml&id=${op}`
      );
    },
    anular() {
      let self = this;
      Notifications.alert.confirm(
        "Anular Operación",
        "¿Desea dar de baja a la operación?",
        "Si Anular",
        function () {
          MovimientoBancarioService.anular(self.current.id)
            .then((response) => {
              Notifications.alert.success("Documento Anulado", "Operación dada de baja");
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error("Anular Transacción", error.response.data.detail);
            });
        }
      );
    },
    conciliar() {
      let self = this;
      let det = Object.assign({}, self.current);
      Notifications.alert.confirm(
        "Aplicar conciliación",
        "¿Esta seguro(a) de ejecturar esta acción?",
        "",
        function () {
          MovimientoBancarioService.conciliar_movimiento(self.current.id, {
            id: det.id,
          })
            .then((response) => {
              Notifications.alert.success("Listo", "Se ha Agregado la Conciliacion.");
              self.refreshCurrent();
            })
            .catch((error) => {
              console.log(error.response.data);
              self.current.errors = error.response.data;
              if (error.response.data.detail) {
                Notifications.alert.error(
                  "Aplicar Conciliación",
                  error.response.data.detail
                );
              }
            });
        }
      );
    },
    showModal(e) {
      e.preventDefault();
    },
  },
};
</script>
